import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LOW_CREDITS_PERCENT } from '@App/app/configs/credits.config';
import { Credits } from '@App/app/entities/admin-panel/credits.model';

@Component({
  selector: 'app-credits-bar',
  templateUrl: './credits-bar.component.html',
  styleUrls: ['./credits-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreditsBarComponent {
  private _credits: Credits;
  percentLeft: number;
  isLowCreditsValue: boolean;
  shouldShowLabel: boolean;

  @Input()
  set credits(credits: Credits | null) {
    this._credits = credits || { enabled: false, limit: 0, value: 0 };
    this.percentLeft = (this._credits.value / this._credits.limit) * 100;
    this.isLowCreditsValue = this.percentLeft < LOW_CREDITS_PERCENT;
    this.shouldShowLabel = this.percentLeft >= 35; // for smaller percentage number the label gets clipped
  }

  get credits(): Credits {
    return this._credits;
  }
}
